var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    xmlSpace: "preserve",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC0UlEQVR4nO2dwW4SURiFx4W60DfwBdT6Nr5G2xh3xkdQEaOu62uocat2hUm1a9fuKrhC85kbrwkmlUJnTjn89/8SEgIDOd89w9yBITNdlyRJkiRJkiRJ0hNgB3gKfAZmbD+z6jIG7tiuIMAV4Dnwk7j8Al4W185w8N/SDu+sSqhrfmu86Iy2+ZE3O/+jOO84FFAmp1YZORTwhXY5cihgSrt8dyhgKd2Wg7uffcDofvYBo/vZB4zupwoIXAX2gY/195hZvb9XnhvWYmmO9goAbgCflrztpCwzvM2pWdoqgD9r/rLBXyxB/klosYB9VmdXY9V2AYdrFPBBY9V2AdM1CphqrP7JkwUs4SQLOINzrHGHrE5uggQF7K1RQE7Cot3QyQqDP7mIw4JD+23TF7HJGYOfX8RUBSwc6N8t2/m6Z1Ru7+tjF3ZAvMlPgBP2fvYBo/vZB4zuZx8wut/QAYHrwF3gWf0H2vHCJHxcHxvXZa5prBosALgNvAJ+sDpl2QPglrtf5xoQuAQ8BOacn/LaB45+21DAfYbjnpufnL4Bga+DDT98c/OT0zcgA+PmJ6dvQAbGzU9O34AMjJufHPuA0f3sA0b3sw8Y3c8+YHQ/+4DR/ewDRvezDxjdzz5gdL++Adkwaj85akE1aj85akE1aj85akE1aj85akE1aj85akE1aj85akE1aj85akE1aj859gGj+9kHjO5nHzC6n33A6H59A7Jh1H5y1IJq1H5y1IJq1H5y1IJq1H5y1IJq1H5y1IJq1H5y1IJq1H5y1IJq1H5y7ANG97MPGN3PPmB0P/uA0f3sA0b3sw8Y3c8+YHQ/+4DR/cpFDGiXE4cCykXOWuXIoYAR7fJo0+P/9ywnLV7Gag7c7Byo5/ZpjVHnAnAZeEM7vC7OnRO1hHHP8/64M69zntfgnzInPCl7CEGuMTatLo+VZ+ZKkiRJkiRJkqRrht9kznv1zAtRRwAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon4);
export default __webpack_public_path__ + "static/media/nav-icon4.7af92250240ead5b33eba35c2902b73c.svg";
export { ForwardRef as ReactComponent };